import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function resolveAssetUrl(value, fallback = '/assets/mystical-logo.png') {
  if (!value || typeof value !== 'string') return fallback;
  const url = value.trim();
  if (!url) return fallback;
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith('//')) return `${window.location.protocol}${url}`;
  if (url.startsWith('/')) return url;
  return `/${url.replace(/^\/+/, '')}`;
}

export function gameImageUrl(game, fallback = '/assets/mystical-logo.png') {
  return resolveAssetUrl(game?.logo_image_url || game?.logo_url || game?.image, fallback);
}

export function handleImageFallback(event, fallback = '/assets/mystical-logo.png') {
  const img = event.currentTarget;
  if (img.dataset.fallbackApplied === '1') return;
  img.dataset.fallbackApplied = '1';
  img.src = fallback;
}
